import React, { useRef, useState } from "react";
import { Box } from "@mui/material";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";

export default function OverflowX({ children, minWidth, setIsBottom }) {
  const userListRef = useRef(null);
  const [isShowUserListRightArrow, setIsShowUserListRightArrow] =
    useState(true);
  const [isShowUserListLeftArrow, setIsShowUserListLeftArrow] = useState(false);

  const onScroll = () => {
    if (userListRef.current) {
      const { scrollWidth, clientWidth, scrollLeft } = userListRef.current;
      const scrollRight = scrollWidth - clientWidth - scrollLeft;
      if (scrollLeft === 0) {
        setIsShowUserListLeftArrow(false);
      } else if (!isShowUserListLeftArrow) {
        setIsShowUserListLeftArrow(true);
      }
      if (scrollRight === 0) {
        setIsShowUserListRightArrow(false);
      } else if (!isShowUserListRightArrow) {
        setIsShowUserListRightArrow(true);
      }
    }
    if (userListRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = userListRef.current;
      if (scrollTop + clientHeight > scrollHeight - 10) {
        setIsBottom(true);
      } else {
        setIsBottom(false);
      }
    }
  };

  return (
    <Box sx={{ position: "relative" }}>
      {isShowUserListLeftArrow && (
        <ArrowCircleLeftIcon
          sx={{
            display: { sm: "block", md: "none" },
            position: "absolute",
            left: 0,
            top: "50%",
            zIndex: 2,
            opacity: 0.5,
          }}
          style={{ color: "#28345E" }}
          fontSize="large"
        />
      )}
      {isShowUserListRightArrow && (
        <ArrowCircleRightIcon
          sx={{
            display: { sm: "block", md: "none" },
            position: "absolute",
            right: 0,
            top: "50%",
            zIndex: 2,
            opacity: 0.5,
          }}
          fontSize="large"
          style={{ color: "#28345E" }}
        />
      )}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "scroll",
        }}
        ref={userListRef}
        onScroll={onScroll}
      >
        <Box sx={{ minWidth }} onScroll={onScroll}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
